export default __webpack_public_path__ + "static/media/infra-22.374a9daf.webp";